import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/content";
import BookButton from "@/components/layout/BookButton";

export default function FinalCTA() {
  return (
    <section className="section-pad relative overflow-hidden" data-testid="home-final-cta">
      <div
        aria-hidden
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(50% 60% at 50% 30%, rgba(215,20,26,0.10) 0%, transparent 60%), #F8F7F4",
        }}
      />
      <div className="container-sp text-center max-w-3xl mx-auto">
        <div className="overline">Your next step</div>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#0D1B2A] mt-4 leading-[1.05]">
          Take the next step with clarity.
        </h2>
        <p className="text-[#4A5568] mt-6 leading-relaxed">
          Whether you're exploring options or ready to apply — we'll meet you
          where you are, without pressure, without noise.
        </p>
        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Link to="/contact#eligibility" className="btn-primary" data-testid="final-cta-eligibility">
            Check My Eligibility <ArrowRight className="w-4 h-4" />
          </Link>
          <BookButton track="general" variant="gold" testId="final-cta-consultation">
            Book Expert Consultation
          </BookButton>
          <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="btn-outline" data-testid="final-cta-whatsapp">
            <MessageCircle className="w-4 h-4" /> Ask on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
